import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const roleHome = {
  SUPER_ADMIN: "/",
  ADMIN: "/",
  MANAGER: "/",
  CASHIER: "/billing",
  BILLING: "/billing"
};

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
